import { useNavigate } from "react-router-dom";
import { Notification } from "../../types/notification";

const NotificationSnippetCard = ({notifications}: {notifications: Notification[]}) => {
  const navigate = useNavigate();

  const handleNotificationClick = async () => {
    navigate("/supplement/notifications");
  };

  return (
    <div className="space-y-4 p-2 h-[50dvh] overflow-y-scroll">
      {Array.isArray(notifications) && notifications?.length === 0 ? (
        <div className="p-12 text-center bg-white rounded-3xl border border-dashed border-slate-200">
          <p className="text-slate-400 font-medium">
            All caught up! No new notifications.
          </p>
        </div>
      ) : (
        Array.isArray(notifications) &&
        notifications?.map((note) => (
          <div
            key={note.notification_id}
            onClick={handleNotificationClick}
            className={`p-6 rounded-2xl border flex gap-4 items-start transition-all cursor-pointer hover:scale-[1.01] active:scale-[0.99] ${note.is_read ? "bg-white border-slate-100 opacity-60" : "bg-white border-emerald-100 shadow-md ring-1 ring-emerald-500/10"}`}
          >
            <div className="flex-1">
              <div className="flex justify-between items-start">
                <div>
                  <p
                    className={`${note.is_read ? "text-slate-600" : "text-slate-900"}`}
                  >
                    {note.message}
                  </p>
                  <p className="text-[10px] text-emerald-600 font-black uppercase tracking-widest mt-1">
                    Click to View Notification
                  </p>
                </div>
                <p className="text-[10px] text-slate-400 font-bold uppercase whitespace-nowrap ml-4">
                  {new Date(note.created_at).toLocaleTimeString("en-IN", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </p>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default NotificationSnippetCard;
